import { Grid, Typography } from "@mui/material";

import { Checkbox } from "@aclymatepackages/atoms";
import { ucFirstLetters } from "@aclymatepackages/formatters";

import DistanceInput from "./DistanceInput";

import OrDivider from "../atoms/OrDivider";
import PlacesAutocomplete from "./autocomplete/PlacesAutocomplete";

import { fetchDirectionsMileage } from "../../helpers/utils/apiCalls";
import { setAddress } from "../../helpers/utils/geography";
import { isObjectEmpty } from "../../helpers/otherHelpers";

const StartEndPointInputs = ({
  type,
  from,
  setFrom,
  to,
  setTo,
  roundTrip,
  clearOtherInputs = () => {},
  setCalculatedMileage,
  setCalcLoading,
  editTransaction,
  dontShowRoundTripOption,
  disabled,
}) => {
  const setDestination = (setter, otherDestination) => async (destination) => {
    editTransaction("distance")("");
    editTransaction("distanceUnit")("");
    if (!destination) {
      return setter("");
    }

    if (otherDestination && !isObjectEmpty(destination)) {
      clearOtherInputs();

      setCalcLoading(true);
      const { place_id: placeId } = destination;
      const totalMileage = await fetchDirectionsMileage(
        { placeId },
        otherDestination
      );
      setCalculatedMileage(totalMileage);
      setCalcLoading(false);
    }

    return setAddress(setter)(destination);
  };

  return (
    <Grid container spacing={1} direction="column" wrap="nowrap">
      <Grid item container spacing={2}>
        <Grid item sm={6}>
          <PlacesAutocomplete
            place={from}
            editPlace={setDestination(setFrom, to)}
            label={`${ucFirstLetters(type)} Starting Point`}
            size="small"
            disabled={disabled}
          />
        </Grid>
        <Grid item sm={6}>
          <PlacesAutocomplete
            place={to}
            editPlace={setDestination(setTo, from)}
            label={`${ucFirstLetters(type)} Destination`}
            size="small"
            disabled={disabled}
          />
        </Grid>
      </Grid>
      {!dontShowRoundTripOption && (
        <Grid item>
          <Checkbox
            label="Was this a round Trip?"
            value={roundTrip}
            editValue={editTransaction("roundTrip")}
            disabled={disabled}
          />
        </Grid>
      )}
    </Grid>
  );
};

const DistanceInputOptions = ({
  inputData,
  editInputData,
  type,
  clearOtherInputs = () => {},
  setCalculatedMileage,
  setCalcLoading,
  oldDbMileageValue,
  dontShowRoundTripOption,
  startAdditionalRow,
  endAdditionalRow,
  disabled,
}) => {
  const { from, to, distance, roundTrip } = inputData;

  const setFrom = editInputData("from");
  const setTo = editInputData("to");

  const distanceClearOtherInputs = () => {
    setFrom("");
    setTo("");
    clearOtherInputs();
    return setCalculatedMileage(0);
  };

  const inputRows = [
    {
      RowComponent: StartEndPointInputs,
      props: {
        editTransaction: editInputData,
        type,
        from,
        setFrom,
        to,
        setTo,
        clearOtherInputs,
        setCalculatedMileage,
        setCalcLoading,
        roundTrip,
        dontShowRoundTripOption,
        disabled,
      },
      title: "Enter Start and End Points",
    },
    {
      RowComponent: DistanceInput,
      props: {
        distance,
        editTransaction: editInputData,
        oldDbMileageValue,
        clearOtherInputs: distanceClearOtherInputs,
        disabled,
      },
      title: "Enter Estimated Distance",
    },
  ];

  const displayRows = [
    startAdditionalRow,
    ...inputRows,
    endAdditionalRow,
  ].filter((row) => row);

  const labelsArray =
    displayRows.length === 3 ? ["Best", "Better", "Good"] : ["Better", "Good"];

  return (
    <Grid container direction="column" spacing={1}>
      {displayRows.map(({ RowComponent, props, title }, idx) => (
        <>
          <Grid item key={`rides-input-row-${idx}`}>
            <Typography variant="h6" gutterBottom>
              {title} ({labelsArray[idx]})
            </Typography>
            <RowComponent {...props} />
          </Grid>
          {idx !== displayRows.length - 1 && (
            <Grid item>
              <OrDivider />
            </Grid>
          )}
        </>
      ))}
    </Grid>
  );
};
export default DistanceInputOptions;
